import { CSSProperties } from "react";

interface LazyImgProps {
  src?: string | null;
  imgKey?: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  style?: CSSProperties;
  className?: string;
}

export function LazyImg({
  src,
  imgKey,
  alt = "",
  width,
  height,
  style,
  className = "",
}: LazyImgProps) {
  if (!src) return null;
  return (
    <img
      key={imgKey || src}
      src={src}
      loading="lazy"
      className={className}
      style={{ ...style, height: height, width: width }}
      alt={alt}
    />
  );
}
